<div
  class="d-flex justify-content-center loader flex-column align-items-center"
  *ngIf="loading || !groups"
>
  <div>
    <mat-spinner color="accent"></mat-spinner>
  </div>
</div>

<mat-toolbar class="d-flex justify-content-between">
  <mat-card-title>Categories</mat-card-title>
  <div class="spacer"></div>
  <button
    class="mr-2"
    mat-mini-fab
    color="primary"
    aria-label="Clear Search"
    (click)="reloadGroups()"
  >
    <fa-icon class="text-white" [icon]="faUndo"></fa-icon>
  </button>
  <button
    mat-mini-fab
    color="primary"
    aria-label="Search Group"
    (click)="openSideNav(sideNavActions.SearchGroup)"
  >
    <fa-icon class="text-white" [icon]="faSearch"></fa-icon>
  </button>
</mat-toolbar>
<div class="p-2 h-100 w-100 relative scrollable pb-5">
  <table
    *ngIf="dataSource?.data"
    mat-table
    [dataSource]="dataSource"
    class="w-100"
  >
    <ng-container matColumnDef="Name">
      <th mat-header-cell *matHeaderCellDef class="group-col">Name</th>
      <td mat-cell *matCellDef="let element">
        <div class="d-flex align-items-center">
          <div
            *ngIf="!element?.logo || element?.logo?.source === ''"
            class="initials sm text-white"
          >
            <fa-icon [icon]="faBook" class="text-white link"></fa-icon>
          </div>
          <div
            *ngIf="element?.logo && element?.logo?.source !== ''"
            class="initials sm"
          >
            <img class="img-fluid" [src]="element.logo.source" />
          </div>
          <p class="ml-2 m-0">{{ element.name }}</p>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="Followers">
      <th mat-header-cell *matHeaderCellDef class="group-col">Followers</th>
      <td mat-cell *matCellDef="let element">
          <p class="ml-2 m-0">{{ element.followers?.length ? element.followers.length : 0 }}</p>
      </td>
    </ng-container>
    <ng-container matColumnDef="Businesses">
      <th mat-header-cell *matHeaderCellDef class="group-col">Businesses</th>
      <td mat-cell *matCellDef="let element">
          <p class="ml-2 m-0">{{ element.businesses ? element.businesses : 0 }}</p>
      </td>
    </ng-container>
    <ng-container matColumnDef="Description">
      <th mat-header-cell *matHeaderCellDef class="group-col">Description</th>
      <td mat-cell *matCellDef="let element">
          <p class="ml-2 m-0">{{ element.description }}</p>
      </td>
    </ng-container>
    <ng-container matColumnDef="Actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>

      <td [ngClass]="'text-center'" mat-cell *matCellDef="let element">
        <div class="d-flex flex-row">
          <button
            (click)="openGroup(element)"
            title="view"
            type="button"
            class="btn btn-outline-primary btn_yellow_mobile btn_yellow"
          >
            Open
          </button>
        </div>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <mat-paginator
    #groupsPaginator
    *ngIf="dataSource?.data"
    [length]="groupsCount"
    [pageSize]="displayLimit"
    [pageIndex]="page"
    [pageSizeOptions]="[5, 10, 25, 100]"
    aria-label="Select page"
    (page)="pageGroups($event)"
  >
  </mat-paginator>
  <!-- <app-map *ngIf="groups" [groups]="groups"></app-map> -->
  <button
    class="fab-bottom-right"
    mat-fab
    color="primary"
    aria-label="Create Category"
    (click)="openSideNav(sideNavActions.NewGroup)"
  >
    <fa-icon [icon]="faPlus" class="text-white"></fa-icon>
  </button>
</div>
